<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                    <div>
                        <h4 class="mb-3">통합 구매 요청</h4>
                        <p class="mb-0">
                            바코드, SKU ID, 옵션ID를 입력하여 자동으로 그로스/로켓 상품을 매칭합니다.<br>
                            ★ 현재는 1688링크만 구매 가능합니다.(다른 링크의 경우 쿠패스 채널톡으로 문의해 주세요)<br>
                            구매요청 후에는 반드시 쿠패스 채널톡으로 말씀해주세요. 구매현황 및 기타문의는 쿠패스 채널톡을 이용해 주세요 ---->
                            <a href="http://pf.kakao.com/_AxcWvxj" target="_blank">
                                <u>쿠패스 전용 채널톡 바로가기</u>
                            </a>
                        </p>
                    </div>
                </div>

                <tab-nav :tabs="true" id="myTab-1">
                    <tab-nav-items :active="true" id="req-tab" ariaControls="req" role="tab" :ariaSelected="true"
                        title="구매대행요청" />
                    <tab-nav-items :active="false" id="list-tab" ariaControls="list" role="tab" :ariaSelected="false"
                        title="구매대행요청내역" />
                </tab-nav>

                <tab-content id="myTabContent">
                    <tab-content-item :active="true" id="req" aria-labelled-by="req-tab">

                        <!-- 상품 추가 입력 -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label>상품 식별자 입력</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control"
                                                               placeholder="바코드, SKU ID, 옵션ID 입력"
                                                               v-model="추가바코드"
                                                               @keyup.enter="addlists">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-primary" @click="addlists">
                                                                <i class="ri-add-line"></i> 추가
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <small class="form-text text-muted">
                                                        바코드(그로스), SKU ID(로켓), 옵션ID(vendorItemId) 자동 인식
                                                    </small>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>1688 구매링크 (선택)</label>
                                                    <input type="text" class="form-control"
                                                           placeholder="1688 링크 입력"
                                                           v-model="기본구매링크">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="showlist">
                            <div class="col-12">
                                <CDataTable
                                    storage-key="unifiedPurchaseRequest.1"
                                    :headers="headers"
                                    :items="lists"
                                    v-model="tableSelectedItem"
                                    :show-select="true"
                                    itemKey="_id">

                                    <!-- 제품정보 컬럼 -->
                                    <template v-slot:제품정보="{ item }">
                                        <div class="d-flex align-items-center" style="min-width:200px;">
                                            <img :src="item.등록이미지" class="img-fluid rounded avatar-80 mr-3"
                                                alt="image" v-if="item.등록이미지">
                                            <div v-if="item.상품명">
                                                {{ item.상품명 }}
                                                <p class="mb-0">
                                                    <small>{{ item.식별자타입 }}: {{ item.바코드 }}</small>
                                                </p>
                                                <p class="mb-0" v-if="item.매칭시스템">
                                                    <span class="badge badge-info">{{ item.매칭시스템 }}</span>
                                                </p>
                                            </div>
                                            <div v-else>
                                                <input type="text" class="form-control" placeholder="상품명입력"
                                                    v-model="item.상품명init" @change="addProductName(item)">
                                                <p class="mb-0">
                                                    <small>{{ item.식별자타입 }}: {{ item.바코드 }}</small>
                                                </p>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- 상품매칭 컬럼 -->
                                    <template v-slot:상품매칭="{ item }">
                                        <div :class="matchclass(item.매칭상태)">{{ item.매칭상태 }}</div>
                                    </template>

                                    <!-- 구매링크 컬럼 -->
                                    <template v-slot:구매링크="{ item }">
                                        <div style="max-width:300px;overflow:hidden;text-overflow: ellipsis;">
                                            <div v-if="item.구매링크 !== undefined">
                                                <a :href="item.구매링크" target="_blank">{{ item.구매링크 }}</a>
                                                <div v-if="item.showspinner">
                                                    <img style="width:20%;"
                                                        :src="require('../../../assets/images/small/loading.gif')">
                                                </div>
                                            </div>
                                            <div v-else>
                                                <input type="text" class="form-control" placeholder="구매링크입력"
                                                    v-model="item.구매링크init" @change="matchoption1(item, item.구매링크init)">
                                            </div>
                                        </div>
                                    </template>

                                    <!-- 옵션1 컬럼 -->
                                    <template v-slot:옵션1_중국어="{ item }">
                                        <div v-if="item.상품매칭 && item.상품매칭.옵션1_중국어 && item.상품매칭.옵션1_중국어.length > 0">
                                            <button class="btn btn-sm btn-outline-primary mr-1 mb-1"
                                                v-for="(a, aindex) in item.상품매칭.옵션1_중국어" :key="aindex"
                                                @click="option1matching(a, item)">
                                                🔍 {{ a.name }}
                                            </button>
                                        </div>
                                        <div v-else>
                                            <button class="btn btn-sm btn-outline-secondary">🔍 Search</button>
                                        </div>
                                    </template>

                                    <!-- 옵션2 컬럼 -->
                                    <template v-slot:옵션2_중국어="{ item }">
                                        <div v-if="item.상품매칭 && item.상품매칭.옵션2_중국어 && item.상품매칭.옵션2_중국어.length > 0">
                                            <button class="btn btn-sm btn-outline-primary mr-1 mb-1"
                                                v-for="(b, bindex) in item.상품매칭.옵션2_중국어" :key="bindex"
                                                @click="option2matching(b, item)">
                                                🔍 {{ b.name }}
                                            </button>
                                        </div>
                                        <div v-else>
                                            <button class="btn btn-sm btn-outline-secondary">🔍 Search</button>
                                        </div>
                                    </template>

                                    <!-- 구매재고 컬럼 -->
                                    <template v-slot:구매재고="{ item }">
                                        {{ item.구매재고 || 0 }}
                                    </template>

                                    <!-- 요청사항 컬럼 -->
                                    <template v-slot:요청사항="{ item }">
                                        <button class="btn btn-sm btn-outline-info" @click="editRequirement(item)">
                                            {{ item.요청사항 || '요청등록' }}
                                        </button>
                                    </template>

                                    <!-- 구매요청수량 컬럼 -->
                                    <template v-slot:구매요청수량="{ item }">
                                        <input type="number" class="form-control" style="width: 80px;"
                                            v-model="item.구매요청수량" min="1">
                                    </template>

                                    <!-- Actions 컬럼 -->
                                    <template v-slot:Actions="{ item }">
                                        <div class="d-flex">
                                            <a class="badge bg-success mr-2" href="javascript:void(0)"
                                                @click="editItem(item)">
                                                <i class="ri-edit-line mr-0"></i>
                                            </a>
                                            <a class="badge bg-warning mr-2" href="javascript:void(0)"
                                                @click="deletelist(item)">
                                                <i class="ri-delete-bin-line mr-0"></i>
                                            </a>
                                        </div>
                                    </template>
                                </CDataTable>
                                <div class="mt-3">
                                    <button type="button" class="btn btn-primary mr-2" @click="requestpurchase">구매대행요청</button>
                                    <button type="button" class="btn btn-secondary mr-2" @click="savereqlist">현재상태저장</button>
                                    <button type="button" class="btn btn-info mr-2" @click="bulkOrder">대량주문</button>
                                </div>
                            </div>
                        </div>
                    </tab-content-item>

                    <tab-content-item :active="false" id="list" aria-labelled-by="list-tab">
                        <!-- 검색 필터 -->
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <label>시작일</label>
                                <input type="date" class="form-control" v-model="startdate">
                            </div>
                            <div class="col-md-3">
                                <label>종료일</label>
                                <input type="date" class="form-control" v-model="enddate">
                            </div>
                            <div class="col-md-2">
                                <label>상품명</label>
                                <input type="text" class="form-control" v-model="상품명" placeholder="상품명">
                            </div>
                            <div class="col-md-2">
                                <label>바코드</label>
                                <input type="text" class="form-control" v-model="바코드" placeholder="바코드">
                            </div>
                            <div class="col-md-2">
                                <label>&nbsp;</label>
                                <div>
                                    <button class="btn btn-primary btn-block" @click="searchHistory">검색</button>
                                </div>
                            </div>
                        </div>

                        <!-- 구매대행요청내역 테이블 -->
                        <div class="row" v-if="showreqlist">
                            <div class="col-12">
                                <CDataTable
                                    storage-key="unifiedPurchaseRequest.2"
                                    :headers="historyHeaders"
                                    :items="reqlists"
                                    itemKey="_id"
                                    :show-select="true"
                                    :items-per-page="20">

                                    <!-- 상품정보 컬럼 -->
                                    <template v-slot:상품정보="{ item }">
                                        <div class="d-flex align-items-center" style="min-width:200px;">
                                            <img :src="item.등록이미지" class="img-fluid rounded avatar-60 mr-2"
                                                alt="image" v-if="item.등록이미지">
                                            <div>
                                                <div class="font-weight-bold">{{ item.상품명 }}</div>
                                                <small class="text-muted">{{ item.바코드 }}</small>
                                                <div v-if="item.reqtype">
                                                    <span class="badge badge-info">{{ item.reqtype }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- 구매링크 컬럼 -->
                                    <template v-slot:구매링크="{ item }">
                                        <div style="max-width:250px;overflow:hidden;text-overflow: ellipsis;">
                                            <a :href="item.구매링크" target="_blank" v-if="item.구매링크">
                                                {{ item.구매링크 }}
                                            </a>
                                            <span v-else class="text-muted">-</span>
                                        </div>
                                    </template>

                                    <!-- 요청일시 컬럼 -->
                                    <template v-slot:요청일시="{ item }">
                                        {{ formatDate(item.요청일) }}
                                    </template>

                                    <!-- 수량 컬럼 -->
                                    <template v-slot:수량="{ item }">
                                        {{ item.구매요청수량 || '-' }}
                                    </template>

                                    <!-- 진행현황 컬럼 -->
                                    <template v-slot:진행현황="{ item }">
                                        <span :class="getStatusClass(item.진행현황)">
                                            {{ item.진행현황 || '구매전' }}
                                        </span>
                                    </template>

                                    <!-- 요청사항 컬럼 -->
                                    <template v-slot:요청사항="{ item }">
                                        <button class="btn btn-sm btn-outline-info" @click="viewRequirement(item)">
                                            {{ item.요청사항 || '요청등록' }}
                                        </button>
                                    </template>
                                </CDataTable>

                                <!-- 액션 버튼들 -->
                                <div class="mt-3">
                                    <button type="button" class="btn btn-success mr-2" @click="exportToExcel">
                                        <i class="ri-file-excel-line"></i> 엑셀 다운로드
                                    </button>
                                    <button type="button" class="btn btn-info mr-2" @click="refreshHistory">
                                        <i class="ri-refresh-line"></i> 새로고침
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- 로딩 상태 -->
                        <div v-else class="text-center py-4">
                            <div class="spinner-border" role="status" v-if="historyLoading">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p v-else class="text-muted">검색 버튼을 클릭하여 구매대행요청내역을 조회하세요.</p>
                        </div>
                    </tab-content-item>
                </tab-content>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import CDataTable from '@/components/common/CDataTable'

export default {
    name: 'UnifiedPurchaseRequest',
    components: {
        CDataTable
    },
    data() {
        return {
            lists: [],
            추가바코드: '',
            기본구매링크: '',
            showlist: true,
            allchecked: false,
            tableSelectedItem: [],

            historyList: [],
            historyLoading: false,

            // 구매대행요청내역 관련
            reqlists: [],
            showreqlist: false,
            startdate: '',
            enddate: '',
            상품명: '',
            바코드: '',

            headers: [
                { text: '제품정보', value: '제품정보', width: '250px', isSlot: true },
                { text: '상품매칭', value: '상품매칭', width: '120px', isSlot: true },
                { text: '구매링크', value: '구매링크', width: '300px', isSlot: true },
                { text: '옵션1_중국어', value: '옵션1_중국어', width: '150px', isSlot: true },
                { text: '옵션2_중국어', value: '옵션2_중국어', width: '150px', isSlot: true },
                { text: '구매재고', value: '구매재고', width: '80px', isSlot: true },
                { text: '요청사항', value: '요청사항', width: '120px', isSlot: true },
                { text: '구매요청수량', value: '구매요청수량', width: '120px', isSlot: true },
                { text: 'Actions', value: 'Actions', width: '100px', isSlot: true }
            ],

            historyHeaders: [
                { text: '상품정보', value: '상품정보', width: '250px', isSlot: true },
                { text: '구매링크', value: '구매링크', width: '250px', isSlot: true },
                { text: '요청일시', value: '요청일시', width: '150px', isSlot: true },
                { text: '수량', value: '수량', width: '80px', isSlot: true },
                { text: '진행현황', value: '진행현황', width: '120px', isSlot: true },
                { text: '요청사항', value: '요청사항', width: '120px', isSlot: true }
            ]
        }
    },
    watch: {
        currentMode(newMode) {
            this.updateModeConfig(newMode)
        }
    },
    mounted() {
        // 기본 날짜 설정 (최근 30일)
        const today = new Date()
        const thirtyDaysAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000))

        this.enddate = today.toISOString().split('T')[0]
        this.startdate = thirtyDaysAgo.toISOString().split('T')[0]
    },
    methods: {
        updateModeConfig(mode) {
            const configs = {
                '제트배송': {
                    title: '제트배송 구매요청',
                    desc1: '바코드를 입력하여 빠른 구매 요청을 진행하세요',
                    desc2: '구매요청 후에는 반드시 쿠패스 채널톡으로 말씀해주세요.',
                    desc3: '구매현황 및 기타문의는 쿠패스 채널톡을 이용해 주세요'
                },
                '샘플검증': {
                    title: '샘플검증 구매요청',
                    desc1: '샘플 주문을 통해 상품 품질을 검증하세요',
                    desc2: '구매요청 후에는 반드시 쿠패스 채널톡으로 말씀해주세요.',
                    desc3: '구매현황 및 기타문의는 쿠패스 채널톡을 이용해 주세요'
                },
                '로켓배송': {
                    title: '로켓배송 구매요청',
                    desc1: 'SKU ID를 입력하여 정확한 상품 매칭을 진행하세요',
                    desc2: '구매요청 후에는 반드시 쿠패스 채널톡으로 말씀해주세요.',
                    desc3: '구매현황 및 기타문의는 쿠패스 채널톡을 이용해 주세요'
                }
            }
            
            const config = configs[mode] || configs['제트배송']
            this.title = config.title
            this.desc1 = config.desc1
            this.desc2 = config.desc2
            this.desc3 = config.desc3
        },
        
        getInputPlaceholder() {
            const placeholders = {
                '제트배송': '바코드 번호를 입력하세요',
                '샘플검증': '상품명을 입력하세요',
                '로켓배송': 'SKU ID를 입력하세요'
            }
            return placeholders[this.currentMode] || '바코드 번호를 입력하세요'
        },

        async addlists() {
            if (!this.추가바코드.trim()) {
                alert('입력값이 필요합니다.')
                return
            }

            const identifier = this.추가바코드.trim()

            // 식별자 타입 판별 및 매칭
            const matchResult = await this.matchProductByIdentifier(identifier)

            const newItem = {
                _id: Date.now().toString(),
                바코드: identifier,
                식별자타입: matchResult.type,
                매칭시스템: matchResult.system,
                상품명: matchResult.productName || null,
                상품명init: '',
                등록이미지: matchResult.image || '',
                매칭상태: matchResult.status,
                구매링크: this.기본구매링크 || undefined,
                구매링크init: '',
                상품매칭: {
                    옵션1_중국어: [],
                    옵션2_중국어: []
                },
                구매재고: 0,
                요청사항: '요청등록',
                구매요청수량: 1,
                checked: false,
                vendorItemId: matchResult.vendorItemId,
                productId: matchResult.productId,
                showspinner: false
            }

            this.lists.push(newItem)
            this.showlist = true
            this.추가바코드 = ''

            // 1688 링크가 있으면 자동 매칭 시도
            if (this.기본구매링크) {
                this.matchoption1(newItem, this.기본구매링크)
            }
        },

        async matchProductByIdentifier(identifier) {
            try {
                // 1. 옵션ID (vendorItemId) 체크 - growthdb에서 검색
                if (identifier.length >= 8 && /^\d+$/.test(identifier)) {
                    const growthResult = await this.searchInGrowthDb(identifier)
                    if (growthResult.found) {
                        return {
                            type: '옵션ID',
                            system: '로켓그로스',
                            status: '매칭완료',
                            productName: growthResult.productName,
                            image: growthResult.image,
                            vendorItemId: identifier,
                            productId: growthResult.productId
                        }
                    }
                }

                // 2. 바코드 체크 - growthdb에서 검색
                const barcodeResult = await this.searchByBarcode(identifier)
                if (barcodeResult.found) {
                    return {
                        type: '바코드',
                        system: barcodeResult.system,
                        status: '매칭완료',
                        productName: barcodeResult.productName,
                        image: barcodeResult.image,
                        vendorItemId: barcodeResult.vendorItemId,
                        productId: barcodeResult.productId
                    }
                }

                // 3. SKU ID 체크 - productdb에서 검색
                const skuResult = await this.searchBySku(identifier)
                if (skuResult.found) {
                    return {
                        type: 'SKU ID',
                        system: '로켓배송',
                        status: '매칭완료',
                        productName: skuResult.productName,
                        image: skuResult.image,
                        vendorItemId: skuResult.vendorItemId,
                        productId: skuResult.productId
                    }
                }

                // 매칭 실패
                return {
                    type: '미확인',
                    system: '매칭실패',
                    status: '매칭실패',
                    productName: '',
                    image: ''
                }

            } catch (error) {
                console.error('상품 매칭 오류:', error)
                return {
                    type: '오류',
                    system: '시스템오류',
                    status: '매칭오류',
                    productName: '',
                    image: ''
                }
            }
        },

        async searchInGrowthDb(vendorItemId) {
            try {
                const response = await axios.post('/api/growth/searchByVendorItemId', {
                    vendorItemId: vendorItemId
                })

                if (response.data && response.data.length > 0) {
                    const product = response.data[0]
                    return {
                        found: true,
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }
                return { found: false }
            } catch (error) {
                console.error('GrowthDB 검색 오류:', error)
                return { found: false }
            }
        },

        async searchByBarcode(barcode) {
            try {
                // growthdb에서 바코드 검색
                const growthResponse = await axios.post('/api/growth/searchByBarcode', {
                    barcode: barcode
                })

                if (growthResponse.data && growthResponse.data.length > 0) {
                    const product = growthResponse.data[0]
                    return {
                        found: true,
                        system: '로켓그로스',
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }

                // productdb에서 바코드 검색
                const productResponse = await axios.post('/api/product/searchByBarcode', {
                    barcode: barcode
                })

                if (productResponse.data && productResponse.data.length > 0) {
                    const product = productResponse.data[0]
                    return {
                        found: true,
                        system: '로켓배송',
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }

                return { found: false }
            } catch (error) {
                console.error('바코드 검색 오류:', error)
                return { found: false }
            }
        },

        async searchBySku(sku) {
            try {
                const response = await axios.post('/api/product/searchBySku', {
                    sku: sku
                })

                if (response.data && response.data.length > 0) {
                    const product = response.data[0]
                    return {
                        found: true,
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }
                return { found: false }
            } catch (error) {
                console.error('SKU 검색 오류:', error)
                return { found: false }
            }
        },

        // 구매대행요청내역 관련 메서드들
        searchHistory() {
            this.showreqlist = false
            this.reqlists = []
            this.historyLoading = true

            const start = this.gettimestamp(this.startdate)
            const end = this.gettimestamp(this.enddate) + (1000 * 60 * 60 * 24) - 1

            axios.post('/api/reqpurchase/getlists', {
                start: start,
                end: end,
                상품명: this.상품명,
                바코드: this.바코드
            })
            .then((res) => {
                this.historyLoading = false
                console.log('구매대행요청내역 조회 결과:', res.data.요청결과)

                if (res.data.reqpurchase && res.data.reqpurchase.length > 0) {
                    // 모든 타입의 구매요청 포함 (제트배송, 샘플검증, 로켓배송)
                    this.reqlists = res.data.reqpurchase.map(item => {
                        return {
                            ...item,
                            _id: item._id || Date.now() + Math.random(),
                            진행현황: item.진행현황 || '구매전',
                            checked: false
                        }
                    })
                    this.showreqlist = true
                } else {
                    this.showreqlist = true
                    alert('조회된 구매대행요청내역이 없습니다.')
                }
            })
            .catch((error) => {
                this.historyLoading = false
                console.error('구매대행요청내역 조회 실패:', error)
                alert('구매대행요청내역 조회에 실패했습니다.')
            })
        },

        refreshHistory() {
            this.searchHistory()
        },

        gettimestamp(date) {
            return new Date(date).getTime()
        },

        formatDate(timestamp) {
            if (!timestamp) return '-'
            const date = new Date(timestamp)
            return date.toLocaleDateString('ko-KR') + ' ' + date.toLocaleTimeString('ko-KR', {
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        getStatusClass(status) {
            const statusClasses = {
                '구매전': 'badge badge-secondary',
                '구매중': 'badge badge-warning',
                '배송중': 'badge badge-info',
                '입고완료': 'badge badge-success',
                '취소': 'badge badge-danger',
                '배송지연예정': 'badge badge-warning',
                '발송완료': 'badge badge-info'
            }
            return statusClasses[status] || 'badge badge-light'
        },

        viewRequirement(item) {
            const requirement = item.요청사항 || '요청사항 없음'
            const reqContent = item.요청내역?.reqcontent || ''
            const reqContentPurchase = item.요청내역?.reqcontentPurchase || ''

            let message = `요청사항: ${requirement}`
            if (reqContent) {
                message += `\n\n추가 요청사항: ${reqContent}`
            }
            if (reqContentPurchase) {
                message += `\n\n구매 요청사항: ${reqContentPurchase}`
            }

            alert(message)
        },

        exportToExcel() {
            if (this.reqlists.length === 0) {
                alert('다운로드할 데이터가 없습니다.')
                return
            }

            // 엑셀 다운로드용 데이터 준비
            const excelData = this.reqlists.map(item => ({
                '요청일시': this.formatDate(item.요청일),
                '상품명': item.상품명,
                '바코드': item.바코드,
                '구매링크': item.구매링크 || '',
                '수량': item.구매요청수량 || '',
                '진행현황': item.진행현황 || '구매전',
                '요청사항': item.요청사항 || '',
                '요청타입': item.reqtype || ''
            }))

            // 엑셀 파일 생성 및 다운로드
            const XLSX = require('xlsx')
            const workBook = XLSX.utils.book_new()
            const workSheet = XLSX.utils.json_to_sheet(excelData)
            XLSX.utils.book_append_sheet(workBook, workSheet, '통합구매대행요청내역')

            const today = new Date().toISOString().split('T')[0]
            XLSX.writeFile(workBook, `통합구매대행요청내역_${today}.xlsx`)
        },

        // 기존 fetchProductInfo 메서드 (호환성을 위해 유지)
        async fetchProductInfo(item) {
            try {
                // 이미 매칭된 경우 스킵
                if (item.매칭상태 === '매칭완료') return

                const matchResult = await this.matchProductByIdentifier(item.바코드)

                // 매칭 결과 적용
                item.식별자타입 = matchResult.type
                item.매칭시스템 = matchResult.system
                item.매칭상태 = matchResult.status
                if (matchResult.productName) {
                    item.상품명 = matchResult.productName
                }
                if (matchResult.image) {
                    item.등록이미지 = matchResult.image
                }
                item.vendorItemId = matchResult.vendorItemId
                item.productId = matchResult.productId
            } catch (error) {
                console.error('상품 정보 조회 실패:', error)
                item.매칭상태 = '조회실패'
            }
        },

        editRequirement(item) {
            const requirement = prompt('요청사항을 입력하세요:', item.요청사항 || '')
            if (requirement !== null) {
                item.요청사항 = requirement || '요청등록'
            }
        },

        async fetchBySkuId(item) {
            item.매칭상태 = '조회중'
            // 실제 API 호출 로직 구현 필요
        },

        allchecklist(checked) {
            this.lists.forEach(item => {
                item.checked = checked
            })
        },

        matchclass(status) {
            const classes = {
                '매칭완료': 'badge bg-success',
                '매칭대기': 'badge bg-warning',
                '조회중': 'badge bg-info',
                '조회실패': 'badge bg-danger',
                '수동입력': 'badge bg-secondary'
            }
            return classes[status] || 'badge bg-secondary'
        },

        addProductName(item) {
            if (item.상품명init) {
                item.상품명 = item.상품명init
                item.매칭상태 = '수동입력'
            }
        },

        matchoption1(index, link) {
            if (!link) return

            const item = this.lists[index]
            item.구매링크 = link
            item.showspinner = true

            // 1688 링크 분석 로직
            this.analyze1688Link(item, link)
        },

        async analyze1688Link(item, link) {
            try {
                // 실제 1688 링크 분석 API 호출
                // nomadreqpo.vue의 로직 참조하여 구현
                item.매칭상태 = '분석중'
                console.log('분석할 링크:', link)

                // 임시로 성공 처리
                setTimeout(() => {
                    item.showspinner = false
                    item.매칭상태 = '매칭완료'
                    item.상품매칭 = {
                        옵션1_중국어: [
                            { name: '옵션1-1', value: 'option1-1' },
                            { name: '옵션1-2', value: 'option1-2' }
                        ],
                        옵션2_중국어: [
                            { name: '옵션2-1', value: 'option2-1' },
                            { name: '옵션2-2', value: 'option2-2' }
                        ]
                    }
                }, 2000)
            } catch (error) {
                console.error('1688 링크 분석 실패:', error)
                item.showspinner = false
                item.매칭상태 = '분석실패'
            }
        },

        option1matching(option, item) {
            item.옵션1_중국어 = option.name
            item.옵션1_value = option.value
        },

        option2matching(option, item) {
            item.옵션2_중국어 = option.name
            item.옵션2_value = option.value
        },

        editItem(item, index) {
            // 편집 모달 또는 기능 구현
            console.log('편집:', item, index)
        },

        deletelist(item) {
            const index = this.lists.indexOf(item)
            if (index > -1) {
                this.lists.splice(index, 1)
            }
            if (this.lists.length === 0) {
                this.showlist = false
            }
        },

        requestpurchase() {
            const checkedItems = this.lists.filter(item => item.checked)
            if (checkedItems.length === 0) {
                alert('구매 요청할 상품을 선택해주세요.')
                return
            }

            // 구매 요청 처리 로직
            console.log('구매 요청:', checkedItems)
            alert('구매 요청이 완료되었습니다.')
        },

        savereqlist() {
            // 현재 상태 저장 로직
            console.log('현재 상태 저장:', this.lists)
            alert('현재 상태가 저장되었습니다.')
        },

        bulkOrder() {
            // 대량 주문 로직
            console.log('대량 주문')
        },

        loadHistoryList() {
            // 구매 요청 내역 로드
            this.historyLoading = true

            // 임시 데이터
            setTimeout(() => {
                this.historyList = [
                    {
                        요청일시: '2024-01-15 10:30',
                        상품명: '테스트 상품 1',
                        구매링크: 'https://1688.com/test1',
                        수량: 10,
                        상태: '처리중'
                    },
                    {
                        요청일시: '2024-01-14 15:20',
                        상품명: '테스트 상품 2',
                        구매링크: 'https://1688.com/test2',
                        수량: 5,
                        상태: '완료'
                    }
                ]
                this.historyLoading = false
            }, 1000)
        }
    }
}
</script>
